import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgForm } from '@angular/forms';
import { NoticeService, Notice } from './notice.service';
import { CODE, COMP_TYPE, LOGON_INFO, SERVER, DATEPICKER } from '../app.constants';
import { INgxMyDpOptions } from 'ngx-mydatepicker';
import $ from 'jquery';
import { Code, CommonService } from '../app.service';
import { Car, CarService } from '../member-kanri/car.service';
import { Company, CompanyService } from '../member-kanri/company.service';
import { Driver, UserService } from '../member-kanri/user.service';
import { MessageService } from '../common/message.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import ImageResize from 'image-resize';


@Component({
    selector: 'notice-show',
    templateUrl: 'notice-show.component.html',
    providers: [NoticeService, CarService, CompanyService, UserService]
})
export class NoticeShowComponent implements OnInit, OnDestroy {

    BASE_URL: string = SERVER.baseURL;

    noticeList: Notice[] = [];
    // carAlertList: any[] = [];

    // (2023.09)車両満了日の2分割
    expiredCarList: any[] = [];
    alertedCarList: any[] = [];
    // (2026.04) 運転免許証の有効期限通知パネル用データ保持変数の追加
    // - UI側（notice-show.component.html）で「運転免許満了通知（満了）」および「（満了30日以内）」の
    //   各パネルにリストを表示させるため、*ngIf="expiredDriverList.length > 0" 等のデータバインディングに利用します。
    // - 既存の車両満了リスト（expiredCarList / alertedCarList）と同じデータ構造および初期化フローで
    //   安全に結合・拡張できるように配列の初期値を空配列で設定しています。
    expiredDriverList: any[] = [];
    alertedDriverList: any[] = [];

    // (2024.12)車両修正
    @ViewChild('f') f: NgForm;
    @ViewChild('df') df: NgForm;

    carList: Car[];
    currentCar: Car;
    // (2026.04) ドライバー管理用変数の追加
    // - driverList: API等から取得したドライバー一覧を保持します。
    // - currentDriver: リストからクリックされて選択された特定のドライバーの情報を保持し、モーダル内でのデータの参照・編集に利用します。
    // - targetDriverList: 車両更新時の「所属営業所ドライバー」の表示調整など、特定の操作に関連するドライバーのリストを保持します。
    driverList: Driver[];
    currentDriver: Driver = new Driver();
    targetDriverList: Driver[] = [];
    photoPreviewEmptyCnt: number = 0;

    branchList: Company[] = [];

    carTypeCodeList: Code[];
    carMakerCodeList: Code[];
    licenseList: Code[];

    myDatePickerOptions_noDisableUntil: INgxMyDpOptions = DATEPICKER.myDatePickerOptions_noDisableUntil;

    constructor(
        private noticeService: NoticeService,
        private carService: CarService,
        private commonService: CommonService,
        private messageService: MessageService,
        private deviceService: DeviceDetectorService,
        public userService: UserService,
        public sanitizer: DomSanitizer,
        public companyService: CompanyService,
    ) { }


    ngOnInit() {
        this.carTypeCodeList = CODE.CAR_TYPE;
        this.carMakerCodeList = CODE.CAR_MAKER;
        this.licenseList = CODE.LICENSE_TYPE;

        //お知らせリストを取得
        this.getNoticeList();

        //車検満了車両リストを取得
        // this.getInspectionExpireCarList();

        // // (2023.09)車両満了日の2分割
        // this.getInspectionExpiredCarList();
        // this.getInspectionAlertedCarList();

        // (2024.12)車両修正
        this.getBranchList();
        this.refreshPage();
    }


    /**
     * お知らせリストを取得
     */
    getNoticeList() {
        this.noticeService.getNoticeList(1, false)
            .take(1).subscribe(
                data => {
                    this.noticeList = data['results'];
                }
            );
    }


    /**
     * 車検満了車両リストを取得
     *
     */
    /**
    getInspectionExpireCarList() {
        const today = new Date();
        this.carAlertList = this.carService.getAllCarList().filter((e: any) =>
                                e.inspection_expire_date &&
                                !e.is_inspection_show &&
                                this.commonService.getDayCnt(today, new Date(e.inspection_expire_date)) < 30
                            );

        if (this.carAlertList.length > 0) {
            //車検満了日の昇順にソートする
            this.carAlertList.sort((a,b) => {
                return +(a.inspection_expire_date.replaceAll('-','')) > +(b.inspection_expire_date.replaceAll('-','')) ? 1 : -1;
            });

            this.carAlertList.forEach(c => {
                c.inspection_expire_date = this.commonService.convertDate(c.inspection_expire_date, 'yyyy-MM-dd', true)
            });
        }

        console.log('carAlertList',this.carAlertList);
    }
     */

    showNoticeDetailModal(notice: Notice) {
        $('#noticeModal .modal-title').text(notice.title);
        $('#noticeModal .modal-body').html(notice.content);
        $('#noticeModal').modal('show');
    }


    // (2024.12)車両修正機能追加
    /**
     * ドライバーリスト取得（combobox用）
     */
    getDriverList() {
        this.userService.getDriverList(1, false, true)
            .subscribe(
                data => {
                    this.driverList = data['results'];
                    this.targetDriverList = this.driverList;

                    // (2024.12) ドライバー満了日の2分割
                    const today = new Date();
                    this.expiredDriverList = [];
                    this.alertedDriverList = [];

                    this.driverList.forEach((e: any) => {
                        if (e.license_expire_date) {
                            const dayCnt = this.commonService.getDayCnt(today, new Date(e.license_expire_date));
                            if (dayCnt < 0) {
                                this.expiredDriverList.push(e);
                            } else if (dayCnt < 30) {
                                this.alertedDriverList.push(e);
                            }
                        }
                    });

                    const sortAndFormat = (list: any[]) => {
                        if (list.length > 0) {
                            //免許満了日の昇順にソートする
                            list.sort((a, b) => {
                                return +(a.license_expire_date.replaceAll('-', '')) > +(b.license_expire_date.replaceAll('-', '')) ? 1 : -1;
                            });

                            list.forEach(d => {
                                Object.assign(d, { license_expire_date_string: this.commonService.convertDate(d.license_expire_date, 'yyyy-MM-dd', true) });
                            });
                        }
                    };

                    sortAndFormat(this.expiredDriverList);
                    sortAndFormat(this.alertedDriverList);
                }
            );
    }

    /**
     * 営業所リストを取得
     */
    getBranchList() {
        if (LOGON_INFO.COMP_TYPE == COMP_TYPE.HEAD || LOGON_INFO.COMP_TYPE == COMP_TYPE.BRANCH)
            this.branchList = this.companyService.getCompanyListForCombo();
    }

    //画面リフレッシュ
    refreshPage(): void {
        //車両情報入力欄をクリア
        this.clearSelectCar();
        this.clearSelectDriver();

        //車両リストを再読み込み（この更新で他車両の担当ドライバーも変わるため）
        this.getCarList();

        //担当ドライバーcombobox表示用のドライバ－リストを再取得
        this.getDriverList();
    }

    //入力欄クリア
    clearSelectCar(): void {
        $('#carUpdateModal').modal('hide');
        this.messageService.clearError();
        this.photoPreviewEmptyCnt = 12;

        this.currentCar = new Car();
        this.currentCar.comp_id = "";
        this.currentCar.car_type = "";
        this.currentCar.car_maker = "";
        this.currentCar.driver_id = 0;
        this.currentCar.car_photos_path_new = [];
        this.currentCar.car_photos_file = [];
        if (this.f) this.f.resetForm(this.currentCar);
    }

    //ドライバー入力欄クリア
    clearSelectDriver(): void {
        $('#driverUpdateModal').modal('hide');
        this.currentDriver = new Driver();
        this.currentDriver.comp_id = "";
        this.currentDriver.license_type = "";
        if (this.df) this.df.resetForm(this.currentDriver);
    }

    exec() {
        switch ($('#confirmModal_btn').text()) {
            case "修正":
                if ($('#carUpdateModal').hasClass('show')) {
                    this.updateCar();
                } else if ($('#driverUpdateModal').hasClass('show')) {
                    this.updateDriver();
                }
                break;
            case "削除":
                // this.deleteCar();
                break;
        }
    }

    setCustomError(control_name: string) {
        this.f.controls[control_name].setErrors({ 'custom': true });
        $('#' + control_name).addClass("is-invalid");
    }

    clearCustomError(control_name: string) {
        this.f.controls[control_name].setErrors(null);
        $('#' + control_name).removeClass("is-invalid");
    }

    //車両番号重複チェック
    isCarNoDuplicate() {
        if (this.carService.isCarnoDuplicate(this.currentCar.car_no_first + this.currentCar.car_no_last, this.currentCar.id)) {
            this.setCustomError("car_no_last");
            return true;
        }
        else {
            this.clearCustomError("car_no_last");
            return false;
        }
    }

    //車台番号重複チェック
    isBodyNoDuplicate() {
        if (this.carService.isBodyNoDuplicate(this.currentCar.body_no, this.currentCar.id)) {
            this.setCustomError("body_no");
            return true;
        }
        else {
            this.clearCustomError("body_no");
            return false;
        }
    }

    isLeaseDate() {
        if (this.currentCar.lease_start_date && this.currentCar.lease_date && this.currentCar.lease_balance && this.currentCar.lease_fee && this.currentCar.lease_withdrawl) {
            // リース開始日、リース満了日、リース残高、リース料/月、リース引落日の全てが入力された場合
            if (this.currentCar.lease_withdrawl < 1 || this.currentCar.lease_withdrawl > 31) {
                this.setCustomError("lease_withdrawl");
                this.messageService.addError("リース引落日は1から31までの数字を入力してください。");
                return true;
            }
            else {
                this.clearCustomError("lease_withdrawl");
                return false;
            }
        } else {
            if (this.currentCar.lease_start_date || this.currentCar.lease_date || this.currentCar.lease_balance || this.currentCar.lease_fee || this.currentCar.lease_withdrawl) {
                // 一部のみ入力された場合
                this.messageService.addError("リース関連項目を全て入力して下さい。");
                return true;
            } else return false;
        }
    }

    //車両更新
    updateCar() {
        if (this.isCarNoDuplicate()) {
            this.messageService.addError("すでに登録済みの車両番号です。");
            return;
        } else if (this.isBodyNoDuplicate()) {
            this.messageService.addError("すでに登録済みの車台番号です。");
            return;
        } else if (this.isLeaseDate()) {
            return;
        }

        this.commonService.showLoading();

        this.carService.updateCar(this.currentCar)
            .subscribe(
                data => {
                    this.carService.fetchAllCarList().then(
                        () => {
                            this.messageService.addInfo("「" + this.currentCar.car_no_first + this.currentCar.car_no_last + "」の車両情報が更新されました。");
                            this.refreshPage();
                            this.commonService.hideLoading();
                        }
                    );
                },
                error => {
                    this.commonService.hideLoading();
                }
            );
    }

    //ドライバー更新
    updateDriver() {
        this.commonService.showLoading();
        this.userService.updateDriver(this.currentDriver)
            .subscribe(
                data => {
                    this.messageService.addInfo("【" + this.currentDriver.name + "】の情報が更新されました。");
                    this.refreshPage();
                    this.commonService.hideLoading();
                },
                error => {
                    this.commonService.hideLoading();
                }
            );
    }

    /**
     * 車両リスト取得
     */
    async getCarList() {
        this.carList = this.carService.getAllCarList();
        // this.changeDateFormat();

        console.log('carList?!', this.carList);

        // 車両満了日の2分割
        const today = new Date();
        this.expiredCarList = [];
        this.alertedCarList = [];

        this.carList.forEach((e: any) => {
            if (e.inspection_expire_date && !e.is_inspection_show) {
                const dayCnt = this.commonService.getDayCnt(today, new Date(e.inspection_expire_date));
                if (dayCnt < 0) {
                    this.expiredCarList.push(e);
                } else if (dayCnt < 30) {
                    this.alertedCarList.push(e);
                }
            }
        });

        const sortAndFormat = (list: any[]) => {
            if (list.length > 0) {
                //車検満了日の昇順にソートする
                list.sort((a, b) => {
                    return +(a.inspection_expire_date.replaceAll('-', '')) > +(b.inspection_expire_date.replaceAll('-', '')) ? 1 : -1;
                });

                list.forEach(c => {
                    Object.assign(c, { expire_date_string: this.commonService.convertDate(c.inspection_expire_date, 'yyyy-MM-dd', true) });
                });
            }
            this.changeDateFormat(list);
        };

        sortAndFormat(this.expiredCarList);
        sortAndFormat(this.alertedCarList);

        console.log('alertedCarList?!', this.alertedCarList);
    }

    /**
     * 車両情報の各日付をdatepicker用に変換
     */
    changeDateFormat(carList: any): void {
        for (var i = 0; i < carList.length; i++) {
            let c: Car = carList[i];
            if (c.placement_date) {
                let sd = new Date(c.placement_date);
                c.placement_date = { jsdate: sd, formatted: this.commonService.convertDate(sd, 'yyyy/MM/dd') };
            }
            if (c.inspection_expire_date) {
                let sd = new Date(c.inspection_expire_date);
                c.inspection_expire_date = { jsdate: sd, formatted: this.commonService.convertDate(sd, 'yyyy/MM/dd') };
            }
            if (c.insurance_expire_date) {
                let sd = new Date(c.insurance_expire_date);
                c.insurance_expire_date = { jsdate: sd, formatted: this.commonService.convertDate(sd, 'yyyy/MM/dd') };
            }
            if (c.lease_date) {
                let sd = new Date(c.lease_date);
                c.lease_date = { jsdate: sd, formatted: this.commonService.convertDate(sd, 'yyyy/MM/dd') };
            }
            if (c.lease_start_date) {
                let sd = new Date(c.lease_start_date);
                c.lease_start_date = { jsdate: sd, formatted: this.commonService.convertDate(sd, 'yyyy/MM/dd') };
            }
        }
    }


    /**
     * 車両情報詳細モーダルを表示する
     */
    carUpdateModalShow(car: Car) {
        console.log('selected?!', car);
        this.setCurrentCar(car);

        $('[href="#nav-home"]').tab('show');  //基本情報tabを初期選択状態とする
        $('#carUpdateModal').modal('show');

        // 所属営業所ドライバーから表示
        const tempList = this.targetDriverList.filter((item) => item.comp_id == car.comp_id);
        const spliceStart = this.targetDriverList.findIndex(elem => elem.comp_id == car.comp_id);
        this.targetDriverList.splice(spliceStart, tempList.length);
        this.targetDriverList = tempList.concat(this.targetDriverList);
    }

    /**
     * (2026.04) ドライバー情報詳細モーダルを表示する
     * 動作原理:
     * 1. 選択された driver オブジェクトを Object.assign で currentDriver にディープコピーし、元のリストデータに意図せず変更が及ばないようにします。
     * 2. license_expire_date (免許満了日) が文字列として存在する場合、Dateオブジェクトに変換し、さらに commonService.convertDate を用いて
     *    UI側の日付コンポーネントが求めるオブジェクト形式 (jsdate と formatted のセット) に整形・再代入します。
     * 3. 最後に jQuery 経由で '#driverUpdateModal' を呼び出し、詳細画面を開きます。
     */
    driverUpdateModalShow(driver: Driver) {
        this.currentDriver = Object.assign({}, driver);
        
        if (this.currentDriver.license_expire_date && typeof this.currentDriver.license_expire_date === 'string') {
            let sd = new Date(this.currentDriver.license_expire_date);
            this.currentDriver.license_expire_date = { jsdate: sd, formatted: this.commonService.convertDate(sd, 'yyyy/MM/dd') };
        }

        $('#driverUpdateModal').modal('show');
    }

    /**
     * 選択車両を保存
     * @param car リストから選択した車両Object
     */
    setCurrentCar(car: Car) {
        this.clearCustomError("car_no_last");
        this.clearCustomError("body_no");
        this.clearCustomError("lease_withdrawl");
        this.currentCar = Object.assign({}, car);
        this.currentCar.driver_id = car.driver_id ? car.driver_id : 0;

        // 写真ファイルの初期設定
        this.currentCar.car_photos_file = [];
        this.currentCar.car_photos_path = [];
        this.currentCar.car_photos_path_new = [];
        this.setFileDownloadUrl(this.currentCar);
        // this.photoPreviewEmptyCnt = this.currentCar.car_photos_path.length >= 12 ? 0 : 12 - this.currentCar.car_photos_path.length;
    }

    setFileDownloadUrl(car: Car) {
        const token: string = sessionStorage.getItem("file_download_token");

        for (let key in car) {
            if (key == "car_photos") {
                if (!!car.car_photos) {
                    const photo_path: string[] = car.car_photos.split("|");
                    for (let i = 0; i < photo_path.length; i++) {
                        car.car_photos_path.push({
                            idx: i,
                            file_path: photo_path[i],
                            preview_url: this.sanitizer.bypassSecurityTrustResourceUrl(this.BASE_URL + "/common/file-preview/?file_path=" + photo_path[i] + "&token=" + token),
                            is_delete: false
                        });
                    }
                    car.car_photos = undefined;
                }
            }

            // (2024.06)複数PDFファイル対応
            else if (this.carService.PDF_ITEM_NAMES.some((name: string) => name == key)) {
                if (car[key]) {
                    car[key + "_path"] = [];
                    const pdf_path: string[] = car[key].split("|");

                    for (let i = 0; i < pdf_path.length; i++) {
                        car[key + "_path"][i] = {
                            idx: i,
                            file_path: pdf_path[i],
                            preview_url: this.BASE_URL + "/common/file-preview/?file_path=" + pdf_path[i] + "&token=" + token,
                            is_delete: false,
                            modal_path: pdf_path[i].slice(pdf_path[i].lastIndexOf('/') + 1)
                        }
                        this.commonService.pdfPreview(car[key + "_path"][i].preview_url, false, key + "_canvas" + i.toString());
                    }
                    car[key] = undefined;
                }
            }
        }
    }

    get_photo_path_filter_list() {
        if (this.currentCar.car_photos_path) {
            return this.currentCar.car_photos_path.filter(p => !p.is_delete);
        } else {
            return [];
        }
    }

    get_pdf_path_filter_list(name: string) {
        if (this.currentCar[name + "_path"]) {
            return this.currentCar[name + "_path"].filter(p => !p.is_delete);
        } else {
            return [];
        }
    }

    /**
     * 添付ファイルをプレビュー表示する
     */
    async fileAttach(e: any) {
        const files: File[] = e.target.files;
        const device_info = this.deviceService.getDeviceInfo();

        if (files.length > 0) {
            //PDF選択対象の項目の場合
            if (e.target.accept == "application/pdf") {
                //添付したファイルがPDFである場合
                if (files[0].type == e.target.accept) {
                    this.currentCar[e.target.name + "_file"] = files[0];
                    this.currentCar[e.target.name + "_add_path"] = {
                        preview_url: URL.createObjectURL(files[0]),
                        preview_safeurl: this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(files[0]) + "#toolbar=0"),
                        new_filename: this.currentCar.car_no_first + this.currentCar.car_no_last + ".PDF"
                    };
                    this.commonService.pdfPreview(URL.createObjectURL(files[0]), false, e.target.name + "_canvas_add");
                }
                //添付したファイルがPDFではない場合
                else {
                    this.file_attach_clear(e.target.name);
                    alert("PDFファイルを添付してください。");
                }
            }
            //イメージ選択対象の項目の場合
            else {
                //添付したファイルにJPG, JPEG以外が含まれているか確認
                let is_exist_not_jpg: boolean = false;
                const re = /(?:\.([^.]+))?$/;
                for (let i = 0; i < files.length; i++) {
                    const ext: string = (re.exec(files[i].name)[1]).toUpperCase();
                    if (files[i].type != "image/jpeg" || (ext != 'JPG' && ext != 'JPEG')) {
                        is_exist_not_jpg = true;
                        break;
                    }
                }

                //添付したファイルにJPG以外が含まれている場合
                if (is_exist_not_jpg) {
                    this.file_attach_clear(e.target.name);
                    alert("JPG、JPEG形式のファイルを添付してください。");
                } else {
                    for (let i = 0; i < files.length; i++) {
                        if (device_info.os.toLowerCase() == "windows") {
                            //イメージサイズ取得
                            let img = new Image();
                            let objectUrl = URL.createObjectURL(files[i]);
                            let img_width = 0;
                            let img_height = 0;
                            img.onload = function () {
                                img_width = img.width;
                                img_height = img.height;
                                URL.revokeObjectURL(objectUrl);
                            };
                            img.src = objectUrl;

                            //イメージリサイズ (img_widthを読み取るために0.2秒timeoutを指定している)
                            setTimeout(async () => {
                                if (img_width > 1600 || img_height > 1600) {
                                    let imageResize;
                                    if (img_width > img_height) {
                                        imageResize = new ImageResize({ width: 1500, format: 'jpg', outputType: "blob" });
                                    } else {
                                        imageResize = new ImageResize({ height: 1500, format: 'jpg', outputType: "blob" });
                                    }
                                    const res = await imageResize.play(files[i]) as Blob;
                                    const f = new File([res], files[i].name, { type: "image/jpeg" });
                                    this.currentCar.car_photos_file.push(f);
                                    this.currentCar.car_photos_path_new.push(this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(f)));
                                } else {
                                    this.currentCar.car_photos_file.push(files[i]);
                                    this.currentCar.car_photos_path_new.push(this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(files[i])));
                                }
                            }, 200);
                        } else {
                            this.currentCar.car_photos_file.push(files[i]);
                            this.currentCar.car_photos_path_new.push(this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(files[i])));
                        }
                    }
                    this.photoPreviewEmptyCnt = this.photoPreviewEmptyCnt - (files.length > this.photoPreviewEmptyCnt ? 0 : files.length);
                }
            }
        }
    }

    /**
     * ファイル添付をキャンセル
     * @param target_element_name 対象項目名
     * @param photo_type ファイルタイプ（車両写真の場合のみ使用）
     * @param idx 対象index番号（車両写真の場合のみ使用）
     */
    file_attach_clear(target_element_name: string, photo_type: string = "", idx: number = 0) {
        //車両写真の場合
        if (target_element_name == "car_photos") {
            //既存アップロード済みファイルの場合
            if (photo_type == "old") {
                this.currentCar.car_photos_path[idx].is_delete = true;
            }
            //新規追加したファイル（アップロード前）の場合
            else {
                this.currentCar.car_photos_file.splice(idx, 1);
                this.currentCar.car_photos_path_new.splice(idx, 1);
            }
            this.photoPreviewEmptyCnt = 12 - (this.get_photo_path_filter_list().length + this.currentCar.car_photos_path_new.length);
            this.photoPreviewEmptyCnt = this.photoPreviewEmptyCnt <= 0 ? 0 : this.photoPreviewEmptyCnt;
        }
        //車検証などPDFの場合
        else {
            if (photo_type == "single") {
                this.currentCar[target_element_name] = undefined;
                this.currentCar[target_element_name + "_file"] = undefined;
                this.currentCar[target_element_name + "_add_path"] = undefined;
            }
            else if (photo_type == "old") {
                this.currentCar[target_element_name + "_path"][idx].is_delete = true;
            }
            else {
                this.currentCar[target_element_name] = undefined;
                this.currentCar[target_element_name + "_file"] = undefined;
                this.currentCar[target_element_name + "_path"] = undefined;
            }
        }
    }

    pdfDownload(item_name: string, file_name: string, idx: number) {
        this.commonService.fileDownload(this.currentCar[item_name + "_path"][idx].file_path, this.currentCar.car_no + '_' + file_name + '.PDF');
    }

    pdfPreview(item_name: string, file_name: string, idx: number) {
        this.commonService.filePreviewModalShow(this.currentCar[item_name + "_path"][idx].file_path, this.currentCar.car_no + '_' + file_name + '.PDF', "PDF");
    }


    ngOnDestroy() {
        //Modalが開いた状態でブラウザの前ページへ移動ボタン押下すると、modalは閉じられるがbackdropが消えない
        //強制的にbackdropを消す
        $(".modal-backdrop").remove();
    }

}



// WEBPACK FOOTER //
// ./src/app/notice/notice-show.component.ts